/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import InputFieldUpdateMixin from 'app/mixins/InputFieldUpdateMixin.js';
import InputEditorButtonsMixin from 'app/mixins/InputEditorButtonsMixin.js';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import ButtonList from 'app/components/common/ButtonList.jsx';
import Utilities from 'app/utility/Utilities.js';
import * as _ from 'underscore';
import { Outlet } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            input: Utilities.deepClone(this.props.input)
        };

        this.closeInputModal = this.closeInputModal.bind(this);
        this.onSave = this.onSave.bind(this);

    }

    closeInputModal(e) {
        let input = this.state.input;

        if (_.isEqual(input, this.props.input)) {
            input.dirty = false;
        }

        this.props.onModalClose(input);

    }

    onSave(e) {
        let input = this.state.input;

        e.preventDefault();

        this.props.onSave(input);
    }

    render() {
        let headerContent = null,
            menuContent = null,
            content = null,
            footerContent = null,
            buttons = [],
            Icon = null,
            modalTitle = 'Feed Settings',
            constants = this.props.app.config.constants,
            validationError = null,
            { children, ...otherProps} = this.props;

        if (this.state.input.subtype !== '') {
            Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.state.input.subtype)];
        } else {
            Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.state.input.type)];
        }


        if (this.state.input.type == constants.INPUT_TYPE_TWITTER) {
            modalTitle = "Twitter Input Settings";
        } else if (this.state.input.type == constants.INPUT_TYPE_INSTAGRAM) {
            modalTitle = "Instagram Input Settings";
        } else if (this.state.input.type == constants.INPUT_TYPE_INSTAGRAM_BUSINESS) {
            modalTitle = "Instagram Professional Input Settings";
        } else if (this.state.input.type == constants.INPUT_TYPE_FACEBOOK_PAGE) {
            modalTitle = "Facebook Page Input Settings";
        }



        headerContent = (
            <div>
                <div className="modal-title-headline">
                    {modalTitle}
                </div>
                <div className="modal-title-subhead">
                    <div className="inline-left">
                        <Icon bare={true}/>
                    </div>
                    {this.state.input.name}
                </div>
            </div>
        );

        if (this.props.errors && this.props.errors.errors && this.props.errors.errors.validation != undefined) {
            const extractString = (error) => {
                if (_.isString(error)) {
                    return error;
                }
                for (let key in error) {
                    return extractString(error[key]);
                }
            };

            validationError = (
                <div className="detail-status error">
					<i className="fa fa-exclamation-circle error"></i>
					<div className="status-message">
                        {extractString(this.props.errors.errors.validation)}
                    </div>
				</div>
            );
        }

        buttons = InputEditorButtonsMixin.getButtons.apply(this, [this.props.baseUrl + this.props.linkPrefix, this.props.router.location.pathname]);

        menuContent = (
            <div>
                <ButtonList
                    {...this.props}
                    buttons={buttons}
                    wrapperClass="editor-tabs in-modal"
                    linkClass="editor-tab-item"
                    activeClass="tab-active"
                    errorClass="tab-error" />
            </div>
        );

        otherProps.input = this.state.input;
        otherProps.changeHandler = FormUtilityMixin.requestChange.bind(this);
        otherProps.textRuleHandler = InputFieldUpdateMixin.requestTextRuleChange.bind(this);
        otherProps.scheduleHandler = InputFieldUpdateMixin.requestScheduleChange.bind(this);
        otherProps.statePath = "input";

        if (this.props.children !== null) {
            content = (
                <div>
                    {validationError}
                    <Outlet context={otherProps}/>
                </div>
            );
        }

        footerContent = (
            <button className="form-button" onClick={this.onSave}>save</button>
        );

        return (
            <Modal
                close={this.closeInputModal}
                headerContent={headerContent}
                menuContent={menuContent}
                content={content}
                footerContent={footerContent}
                contentClass="modal-content-padding"/>
        );
    }

};

InputModal.displayName = "InputModal";

InputModal.propTypes = {
    input: PropTypes.object,
    userPerms: PropTypes.object,
    routeViewType: PropTypes.number,
    errors: PropTypes.object,
    onModalClose: PropTypes.func,
    onSave: PropTypes.func,
    linkPrefix: PropTypes.string,
    trialEligible: PropTypes.bool,
    baseUrl: PropTypes.string,
    stateKey: PropTypes.string
};

InputModal.defaultProps = {
    input: {},
    userPerms: {},
    routeViewType: 0,
    errors: null,
    onModalClose: () => {},
    onSave: () => {},
    linkPrefix: 'new/configure/input',
    trialEligible: false,
    baseUrl: '/share/automate/',
    stateKey: 'input'
};

export default InputModal;
